module.exports = __webpack_public_path__ + "images/party-crasher-b590cf96cb525c5e0b463b6f36cd824b.png";